import { bootstrapApplication } from "@angular/platform-browser";
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeCs from '@angular/common/locales/cs';
import localeDe from '@angular/common/locales/de';
import localeEs from '@angular/common/locales/es';
import localePl from '@angular/common/locales/pl';
import { appConfig } from "./app/app.config";
import { AppComponent } from "./app/app.component";

// Register all locales used in the application
registerLocaleData(localeFr, 'fr');
registerLocaleData(localeCs, 'cs');
registerLocaleData(localeDe, 'de');
registerLocaleData(localeEs, 'es');
registerLocaleData(localePl, 'pl');

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
